import React, { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalHeader } from '../../components/form/ModalHeader';
import { Form, Modal } from 'react-bootstrap';
import { DashboardDialogsAssetsSelect } from './DashboardDialogsAssetsSelect';
import { DashboardDialogsSiteSelect } from './DashboardDialogsSiteSelect';
import { FormModalFooter } from '../../components/form/FormModalFooter';
import { DashboardDialogAssetsRequestPayloadFactory } from './DashboardDialogAssetsRequestPayloadFactory';
import { DashboardDialogSelectOption } from './types/DashboardDialogSelectOption';
import { api } from '../../functions/api';
import { ApiPath } from '../../api/ApiPath';
import toast from 'react-hot-toast';
import ModalContext from 'react-bootstrap/ModalContext';
import { useSavingToastMessages } from '../../hooks/useSavingToastMessages';
import { FormSelectOption } from '../../components/form/FormSelect';
import { Site } from '../../sites/dto/Site';

export const DashboardReturnDialog: FC = () => {
  const { t } = useTranslation();
  const [assets, setAssets] = useState<DashboardDialogSelectOption[]>([]);
  const [destinationSite, setDestinationSite] = useState<FormSelectOption<Site> | null>(null);
  const { onHide } = useContext(ModalContext);
  const messages = useSavingToastMessages();

  const canSubmit = assets.length > 0 && destinationSite;

  return (
    <>
      <ModalHeader>{t('Return assets')}</ModalHeader>

      <form
        onSubmit={async (event) => {
          event.preventDefault();

          if (canSubmit) {
            const payload = new DashboardDialogAssetsRequestPayloadFactory(assets).getRequestPayload();

            await toast.promise(
              api({
                method: 'put',
                url: ApiPath.DashboardReturnedAssets,
                data: {
                  ...payload,
                  destinationSiteId: destinationSite.value.id,
                },
              }),
              messages,
            );

            onHide();
          }
        }}
      >
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>{t('Return to site')}</Form.Label>
            <DashboardDialogsSiteSelect
              onChange={setDestinationSite}
              value={destinationSite}
              placeholder={t('Select destination site').toString()}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{t('Assets to return')}</Form.Label>
            <DashboardDialogsAssetsSelect onChange={setAssets} />
          </Form.Group>
        </Modal.Body>

        <FormModalFooter disabled={!canSubmit} />
      </form>
    </>
  );
};
